import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { crmUnreadSMS } from './queryKeys';
import envVars from '../../../constants/envVars';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
const useGetUnreadSmsCount = () => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryFn: () => axios.get(`${envVars.API_COMMERCE_HOSTNAME}crm/backoffice/unread-sms-count`, {
            ...additional
        }),
        queryKey: [crmUnreadSMS]
    });
};
export default useGetUnreadSmsCount;
